export default __webpack_public_path__ + "static/media/HowToChangeYourMind.f0d04759.png";